import { createFileRoute } from "@tanstack/react-router";
import { PortalPolicyV2Page } from "@/components/v2/pages/portal-policy-v2-page";

export const Route = createFileRoute("/portal/policy")({
  component: PortalPolicyV2Page,
});
